"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = require("./styles");
const utils_1 = require("./utils");
const Mask = ({ padding = 10, wrapperPadding = 0, onClick, onClickHighlighted, styles = {}, sizes, className, highlightedAreaClassName, maskId, clipId, }) => {
    const maskID = maskId || uniqueId('mask__');
    const clipID = clipId || uniqueId('clip__');
    const getStyles = (0, styles_1.stylesMatcher)(styles);
    const [px, py] = (0, utils_1.getPadding)(padding);
    const [wpx, wpy] = (0, utils_1.getPadding)(wrapperPadding);
    const { w, h } = (0, utils_1.getWindow)();
    const width = (0, utils_1.safe)((sizes === null || sizes === void 0 ? void 0 : sizes.width) + px * 2);
    const height = (0, utils_1.safe)((sizes === null || sizes === void 0 ? void 0 : sizes.height) + py * 2);
    const top = (0, utils_1.safe)((sizes === null || sizes === void 0 ? void 0 : sizes.top) - py - wpy / 2);
    const left = (0, utils_1.safe)((sizes === null || sizes === void 0 ? void 0 : sizes.left) - px - wpx / 2);
    const windowWidth = w - wpx;
    const windowHeight = h - wpy;
    const maskAreaStyles = getStyles('maskArea', {
        x: left,
        y: top,
        width,
        height,
    });
    return (react_1.default.createElement("div", { style: getStyles('maskWrapper', {}), onClick: onClick, className: className },
        react_1.default.createElement("svg", { width: windowWidth, height: windowHeight, xmlns: 'http://www.w3.org/2000/svg', style: getStyles('svgWrapper', {
                windowWidth,
                windowHeight,
                wpx,
                wpy,
            }) },
            react_1.default.createElement("defs", null,
                react_1.default.createElement("mask", { id: maskID },
                    react_1.default.createElement("rect", { x: 0, y: 0, width: windowWidth, height: windowHeight, fill: 'white' }),
                    react_1.default.createElement("rect", { style: maskAreaStyles, 
                        // Needs for Safari, as we pass any value, css rx will apply.
                        rx: maskAreaStyles.rx ? 1 : undefined })),
                react_1.default.createElement("clipPath", { id: clipID },
                    react_1.default.createElement("polygon", { points: `0 0, 0 ${windowHeight}, ${left} ${windowHeight}, ${left} ${top}, ${left + width} ${top}, ${left + width} ${top + height}, ${left} ${top + height}, ${left} ${windowHeight}, ${windowWidth} ${windowHeight}, ${windowWidth} 0` }))),
            react_1.default.createElement("rect", { style: getStyles('maskRect', {
                    windowWidth,
                    windowHeight,
                    maskID,
                }) }),
            react_1.default.createElement("rect", { style: getStyles('clickArea', {
                    windowWidth,
                    windowHeight,
                    top,
                    left,
                    width,
                    height,
                    clipID,
                }) }),
            react_1.default.createElement("rect", { style: getStyles('highlightedArea', {
                    x: left,
                    y: top,
                    width,
                    height,
                }), className: highlightedAreaClassName, onClick: onClickHighlighted }))));
};
exports.default = Mask;
function uniqueId(prefix) {
    return prefix + Math.random().toString(36).substring(2, 16);
}
//# sourceMappingURL=Mask.js.map